// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-aviso-js": () => import("./../../../src/pages/aviso.js" /* webpackChunkName: "component---src-pages-aviso-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-mail-js": () => import("./../../../src/pages/mail.js" /* webpackChunkName: "component---src-pages-mail-js" */)
}

